<script>
import MeetingToolbar from '../channel/meeting-toolbar.vue'

export default {
  name: 'MeetingItem',
  components: { MeetingToolbar },
  props: {
    meeting: { type: Object, required: true },
  },

  computed: {
    other() {
      // andere Person bestimmen
      const { organizer, invitee } = this.meeting
      if (!organizer || !invitee) return {}
      return String(organizer.email) === String(this.$storage.user.email) ? invitee : organizer
    },
    isOrganizer() {
      return this.meeting.organizer?.email === this.$storage.user.email
    },
    title() {
      return this.meeting.subject || '1:1 Meeting'
    },
    subtitle() {
      const withName = this.other?.name || this.other?.email || ''
      return withName ? `${withName}` : ''
    },
    // Fallbacks, falls dein Serializer dt_start/dt_end liefert
    startIso() {
      return this.meeting.startTime || this.meeting.dt_start
    },
    endIso() {
      return this.meeting.endTime || this.meeting.dt_end
    },
    avatarUrl() {
      // Falls dein Backend kein Bild liefert: schöner Fallback via UI Avatars
      const name = encodeURIComponent(this.other?.name || this.other?.email || 'User')
      let url = `https://ui-avatars.com/api/?name=${name}&size=128&background=0D8ABC&color=fff`
      return this.other.avatar || url
    },
  },
  methods: {
    fmt(iso) {
      if (!iso) return ''
      // einfache lokale Formatierung; gern durch dayjs/Intl ersetzen
      const d = new Date(iso)
      const date = d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
      const time = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
      return `${date} · ${time}`
    },
    fmtTime(iso) {
      if (!iso) return ''
      return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
    },
    onMeetingRescheduled(event) {
      let updates = { status: 'pending' }
      let data = event.response
      if (data.startTime) updates.startTime = data.startTime
      if (data.endTime) updates.endTime = data.endTime
      if (data.subject) updates.subject = data.subject
      this.$emit('update:meeting', { ...this.meeting, ...updates })
    },
  }
}
</script>

<template>
  <div class="card mb-2">
    <div class="card-header d-flex align-items-center">
      <b class="flex-fill">{{ title }}</b>
    </div>

    <div class="card-body d-flex align-items-center py-2">
      <img :src="avatarUrl" class="rounded-circle object-fit-cover me-3" style="height:3rem;width:3rem;" alt="Avatar">
      <div class="flex-fill">
        <div class="text-muted">
          <i class="fas fa-calendar-alt me-1"></i>
          {{ meeting.startTime }} – {{ meeting.endTime }}
        </div>
        <div>mit <b>{{ other.name || other.email }}</b></div>
        <div v-if="meeting.description" class="text-muted small mt-1">{{ meeting.description }}</div>
      </div>
    </div>

    <div class="card-footer">
      <meeting-toolbar
        :ics-uid="meeting.ics_uid"
        :status="meeting.status"
        :is-other-user="!isOrganizer"
        @status-changed="$emit('update:meeting', { ...meeting, status: $event.status })"
        @rescheduled="onMeetingRescheduled($event)"
      />
    </div>
  </div>
</template>
